"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateToString = void 0;
const types_1 = require("./types");
/**
 * Converts client state value to a string, which could be useful for debugging or metrics.
 * @param state - the state of the client
 * @public
 */
function stateToString(state) {
    var _a;
    return (_a = states.get(state)) !== null && _a !== void 0 ? _a : unknown;
}
exports.stateToString = stateToString;
// TODO: generate this from the enum.
const unknown = 'Unknown';
const states = new Map([
    [types_1.ClientState.Failed, 'Failed'],
    [types_1.ClientState.NoBrowserSupport, 'NoBrowserSupport'],
    [types_1.ClientState.NoAudioConsent, 'NoAudioConsent'],
    [types_1.ClientState.Disconnecting, 'Disconnecting'],
    [types_1.ClientState.Disconnected, 'Disconnected'],
    [types_1.ClientState.Connecting, 'Connecting'],
    [types_1.ClientState.Connected, 'Connected'],
    [types_1.ClientState.Starting, 'Starting'],
    [types_1.ClientState.Stopping, 'Stopping'],
    [types_1.ClientState.Recording, 'Recording'],
]);
//# sourceMappingURL=state.js.map